import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import Logo from '../../ui/Logo';
import LangSelector from '../../components/LangSelector';
import { NavLink, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import OfflineModeIndicator from '../../components/OfflineModeIndicator';
import Button from '../../ui/Button';
import { useTranslation } from 'react-i18next';
import LogoutIcon from '../../assets/icons/logout.svg';
const PageHeader = ({ logoSize, title, countDownTimer, logoLink, container = 'container', logoutButton, }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    return (_jsx("header", { className: "page-header", children: _jsx("div", { className: container, children: _jsxs("div", { className: "header-content-wrapper", children: [_jsxs("div", { className: "header-content-row row--top screenshot-content", children: [_jsx(NavLink, { to: logoLink, children: _jsx(Logo, { size: logoSize }) }), title] }), _jsxs("div", { className: "header-content-row row--bottom", children: [_jsx(OfflineModeIndicator, {}), countDownTimer, _jsx(LangSelector, {}), logoutButton && (_jsx("div", { className: "logout-button", children: _jsx(Button, { onClick: () => navigate(APP_ROUTES.adminLogin), label: t('button.logout'), icon: _jsx(LogoutIcon, {}) }) }))] })] }) }) }));
};
export default PageHeader;
